export const client_secret = "0WWp3tl5AmBTlhePLnymyQjwMa8SFqGmlZc0Edff";
export const client_id = "2";
export const grant_type = "password";
